import LoadingComponent from '@/pages/components/common/LoadingComponent'
import Loadable from 'react-loadable'

// 招募
export default [
  {
    path: '/courierView/recruit_scheduleSuccess', // 预约成功
    component: Loadable({
      loader: () => import('@/pages/recruit/scheduleSuccess/main'),
      loading: LoadingComponent
    })
  },
  {
    path: '/courierView/recruit_waitingTrain', // 等待培训
    component: Loadable({
      loader: () => import('@/pages/recruit/waitingTrain/main'),
      loading: LoadingComponent
    })
  },
  {
    path: '/courierView/recruit_examExplanation', // 考试须知
    component: Loadable({
      loader: () => import('@/pages/recruit/examExplanation/main'),
      loading: LoadingComponent
    })
  },
  {
    path: '/courierView/recruit_examSuccess', // 考试成功
    component: Loadable({
      loader: () => import('@/pages/recruit/examSuccess/main'),
      loading: LoadingComponent
    })
  },
  {
    path: '/courierView/recruit_examError', // 考试未通过
    component: Loadable({
      loader: () => import('@/pages/recruit/examError/main'),
      loading: LoadingComponent
    })
  },
  {
    path: '/courierView/recruit_trainerEvaluation', // 评价页
    component: Loadable({
      loader: () => import('@/pages/recruit/trainerEvaluation/main'),
      loading: LoadingComponent
    })
  },
  {
    path: '/courierView/recruit_blank', // 中间页，处理逻辑跳转
    component: Loadable({
      loader: () => import('@/pages/recruit/blank/main'),
      loading: LoadingComponent
    })
  },
  {
    path: '/courierView/recruit_trainingTest', // 考试页
    component: Loadable({
      loader: () => import('@/pages/recruit/trainTest/main'),
      loading: LoadingComponent
    })
  },
  {
    path: '/courierView/recruit_waitingExamine', // 等待审核
    component: Loadable({
      loader: () => import('@/pages/recruit/waitingExamine/main'),
      loading: LoadingComponent
    })
  },
  {
    path: '/courierView/recruit_examineNoPass', // 审核未通过
    component: Loadable({
      loader: () => import('@/pages/recruit/examineNoPass/main'),
      loading: LoadingComponent
    })
  },
  {
    path: '/courierView/recruit_cancelTrain', // 取消培训
    component: Loadable({
      loader: () => import('@/pages/recruit/cancelTrain/main'),
      loading: LoadingComponent
    })
  },
  {
    path: '/courierView/recruit_noJoinTrain', // 培训未到场
    component: Loadable({
      loader: () => import('@/pages/recruit/noJoinTrain/main'),
      loading: LoadingComponent
    })
  },
  {
    path: '/courierView/recruit_eliminate', // 淘汰页
    component: Loadable({
      loader: () => import('@/pages/recruit/eliminate/main'),
      loading: LoadingComponent
    })
  },
  {
    path: '/courierView/recruit_appointmentSelect', // 选择培训场次
    component: Loadable({
      loader: () => import('@/pages/recruit/appointmentSelect/main'),
      loading: LoadingComponent
    })
  },
  {
    path: '/courierView/recruit_citySelect', // 选择城市站点
    component: Loadable({
      loader: () => import('@/pages/recruit/citySelect/main'),
      loading: LoadingComponent
    })
  },
  {
    path: '/courierView/recruit_printWorkCard', // 打印发放工牌
    component: Loadable({
      loader: () => import('@/pages/recruit/printWorkCard/main'),
      loading: LoadingComponent
    })
  },
  {
    path: '/courierView/orderSet', // 接单设置
    component: Loadable({
      loader: () => import('@/pages/orderSet/main'),
      loading: LoadingComponent
    })
  },
  //   {
  //     path: '/courierView/vehicle', // 交通工具
  //     component: Loadable({
  //       loader: () => import('@/pages/vehicleSet/main'),
  //       loading: LoadingComponent
  //     })
  //   },
  {
    path: '/courierView/recruit/info-collection',
    component: Loadable({
      loader: () => import('@/pages/recruit/InfoCollection'),
      loading: LoadingComponent
    })
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recruit/applyChangeCity/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/recruit/applyChangeCity'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recruit/entry/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/recruit/entry'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recruit/equipmentPayInfo/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/recruit/equipmentPayInfo'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recruit/equipmentPayInfoNew/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/recruit/equipmentPayInfoNew'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recruit/editAddress/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/recruit/editAddress'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recruit/main'),
      loading: LoadingComponent
    }),
    path: '/courierView/recruit/main'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recruit/waitReceiving/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/recruit/waitReceiving'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recruit/selectCity/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/recruit/selectCity'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recruit/sureReceiving/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/recruit/sureReceiving'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recruit/certificationDesc/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/recruit/certificationDesc'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recruit/weedout/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/recruit/weedout'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recruit/alreadyLogOff/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/recruit/alreadyLogOff'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recruit/myInfo/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/recruit/myInfo'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recruit/healthCertification/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/recruit/healthCertification'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recruit/voiceCertification/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/recruit/voiceCertification'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recruit/waitingAudit/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/recruit/waitingAudit'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recruit/selectRecruitType/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/recruit/selectRecruitType'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recruit/enrollEquipment/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/recruit/enrollEquipment'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recruit/waitingAuditing/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/recruit/waitingAuditing'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recruit/sureIdentity/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/recruit/sureIdentity'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recruit/checkVehicle/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/recruit/checkVehicle'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recruit/vehicleInfo/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/recruit/vehicleInfo'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recruit/vehicleWaiting/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/recruit/vehicleWaiting'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recruit/joinWechat/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/recruit/joinWechat',
    meta: {
      title: '添加站点微信'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recruit/equipmentSurePay/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/recruit/equipmentSurePay'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recruit/equipmentPayInfoNewTwo/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/recruit/equipmentPayInfoNewTwo',
    meta: {
      title: '缴费说明'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recruit/jumpQueue/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/recruit/jumpQueue',
    meta: {
      title: '排队等待'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recruit/jumpQueueCompleted/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/recruit/jumpQueueCompleted',
    meta: {
      title: '排队等待'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/recruit/equipmentDetails/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/recruit/equipmentDetails',
    meta: {
      title: '套餐详情'
    }
  }
]
